export const checkErrorIfMemberLevelEnabled = (args: {
  silverLevel: number | null;
  goldLevel: number | null;
  diamondLevel: number | null;
}) => {
  const { silverLevel, goldLevel, diamondLevel } = args;

  if (silverLevel !== null && silverLevel >= 0) {
    return false;
  }
  if (goldLevel !== null && goldLevel >= 0) {
    return false;
  }
  if (diamondLevel !== null && diamondLevel >= 0) {
    return false;
  }
  return true;
};
